import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import { useParams } from "./helper/useParamsHook";
//store 
import {
  setSort, getGlobalDataApi, getInitialDataApi,
  useFetchFacilityListDataMutation, setLang, setFilterObject,
  setCityData,
  setActivityFacilityData,
  setLoading,
  setLocation,
  setLoader
} from "./configureStore";
//helpers
import isObjectEmpty from "./helper/emptyObj";
import GenerateSearchListParams from "./helper/resultsGroup";
import emptyFilters from "./helper/emptyFilters";
// components
import Search from "./components/search";
import Pills from "./components/pills";
import Loader from "./components/loader";
import LayoutMap from "./components/layoutMap";
import Cards from "./components/card-filters/cards";
const createQueryObject = (obj) => {
  let queryObj = {};
  for (const [key, value] of obj.entries()) {
    if (!queryObj.hasOwnProperty(key)) {
      queryObj[key] = [];
    }
    queryObj[key].push(value)
  }
  return queryObj;
}



/**
 * The main component of the application.
 * @param {Object} props - The component props.
 * @returns {JSX.Element} - The rendered component.
 */
const App = (props) => {
  const locale = window.initialState.locale;
  const url = window.initialState.url;
  const dispatch = useDispatch();
  const [loaded, setHasLoaded] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [searchParams, setSearchParams] = useParams();
  const [hasMap, setHasMap] = useState(false);
  const [globalDataFetch] = getGlobalDataApi.endpoints.fetchGlobalData.useLazyQuery();
  const [initialDataFetch] = getInitialDataApi.endpoints.fetchInitialData.useLazyQuery();
  const [facilityListFetch] = useFetchFacilityListDataMutation();
  const searchData = useSelector((state) => state.searchData);
  const initialData = useSelector((state) => state.initialData);
  const global = useSelector((state) => state.global);
  const facilityList = useSelector((state) => state.facilityList);
  useEffect(() => {
    if (searchParams.get('sort') === 'distance') {
      searchParams.set('sort', "az");
    }

    const fetchData = async () => {
      let coords = null;
      let overide = false;
      if(searchParams.get('lat') && searchParams.get('lng') && window.initialState.page === "search"){
        coords = {};
        coords.lat = searchParams.get('lat');
        coords.lng = searchParams.get('lng');
        overide = {
          sort : "distance"
        }
      }
      const searchListParams = GenerateSearchListParams(url, searchParams, coords,overide);

      const promises = {};
      promises.promise1 = globalDataFetch({ url });
      promises.promise2 = initialDataFetch({ url });
      if(window.initialState.page === 'search'){
        promises.promise3 = facilityListFetch(searchListParams);
      }
      await Promise.all(Object.values(promises)).then((args) => {
        dispatch(setLang({ locale, url: url }))
        setDataLoaded(true);
        return args
      });
    }
    fetchData().catch((error) => {
      console.error(error);
    })
    // check on which page is the app
    if (window.initialState.page === "search") {
      setHasMap(true)
    }
    document.querySelector('body').classList.add('loaded');
  }, [])
  // get data from url params
  useEffect(() => {
    if (!dataLoaded) return
    const params = createQueryObject(searchParams);
    const queryKeysArr = Object.keys(params);
    const promises = [];
    queryKeysArr.forEach((key) => {
      if (key === "sort") {
       if (params["sort"][0] === "distance" && !queryKeysArr.includes("lat") && !queryKeysArr.includes("lng")){
          promises.push(dispatch(setSort({ value: "az" })));
        } else {
          promises.push(dispatch(setSort({ value: params["sort"][0] })));
        }
      }
      else if (key === "amenity") {
        promises.push(filtrationFunc(
          key,
          initialData["amenities"],
          params
        ));
      } else if (key === "activityGroup") {
        promises.push(filtrationFunc(
          key,
          initialData["activitiesGroup"],
          params
        ));

      } else if (key === "discountCategory") {
        promises.push(filtrationFunc(
          key,
          initialData["discountCategories"],
          params
        ));
      }
      else if (key === "city") {
        promises.push(dispatch(setCityData({ name: params["city"][0], value: params["city"][0] })));
      } else if (key === "activityFacility") {
        promises.push(dispatch(setActivityFacilityData({ name: params["activityFacility"][0], value: params["activityFacility"][0] })));
      }
    });
    if(queryKeysArr.includes("lat") && queryKeysArr.includes("lng") && hasMap){
      promises.push(dispatch(setLocation({ location: { lat: params["lat"][0], lng: params["lng"][0] }, checked: true })));
    }
    Promise.all(promises).then((args) => {
      setHasLoaded(true);
      return args
    });
  }, [dataLoaded]);

  // Check filters object in redux and for each, set url param with its values
  useEffect(() => {
    // on load prevent entering  only when filter is added/removed
    if (!loaded) {
      return;
    }
    let query = {};
    let cards = [];
    for (const [key, value] of Object.entries(searchData.filters)) {
      if (!isObjectEmpty(value)) {
        let param = Object.keys(value);
        query[key] = param;
      }
    }
    if (searchData.cards.length) {
      searchData.cards.forEach((card) => {
        cards.push(card);
      });
      query["cards"] = cards;
    }
    if (searchData.city.value !== "") {
      query["city"] = searchData.city.value;
    }
    if (searchData.activityFacility.value !== "") {
      query["activityFacility"] = searchData.activityFacility.value;
    }
    query["sort"] = searchData.sort;
    if(!isObjectEmpty(searchData.location) && !searchData.location.hasOwnProperty('blocked') && !hasMap){
      query["lat"] = searchData.location.lat;
      query["lng"] = searchData.location.lng;
    }
    setSearchParams(query)
  }, [searchData]);
  // fetch data when loading is true
  useEffect(() => { 
    if(facilityList.loading && window.initialState.page !== 'search') {
      dispatch(setLoading(false));
      return;
    }
    if(facilityList.loading){
      const searchParams = new URLSearchParams(window.location.search);
      const coords = isObjectEmpty(searchData.location) ? null : searchData.location;
      const searchListParams = GenerateSearchListParams(
        global.url,
        searchParams,
        coords,
      );
      facilityListFetch(searchListParams).catch((err) => {
        console.error('failed to fetch facility list' + err);
      });
      if(global.loading){
        dispatch(setLoader(false));
      }
    }
  },[facilityList.loading])
  const filtrationFunc = (type, data, router) => {
    const routerArr = [].concat(router[type]);
    const obj = {
    }
    data.forEach((item) => {
      const filter = routerArr.filter((el) => el == item[type + "Id"]);
      if (filter.length) {
        let name = null;
        if (type === "activityGroup") {
          name = item.activityGroupName;
        } else if (type === "amenity") {
          name = item.name;
        } else if (type === "discountCategory") {
          name = item.name;
        }
        let itemObj = {
          [item[type + "Id"]]: {
            name: name
          }
        }
        Object.assign(obj, itemObj)
      }
    });
    return dispatch(setFilterObject({ type: type, obj: obj }));
  };

  if (!loaded) {
    return <Loader />
  }

  return (
    <>
      {facilityList.loading || global.loading ? <Loader />:null}
      <Search hasMap={true} />
      {!emptyFilters(searchData.filters) ?<Pills /> :null}
      {
        hasMap ? <LayoutMap props={props} /> : <Cards global={global} initialData={initialData} />
      }

    </>
  );
};

export default App;

